export enum UserStatus {
  None = 0,
  NewAccount = 1,
  Active = 2,
  DeActive = 3,
  Blocked = 4,
  Deleted = 5
}
